import { useNavigate } from 'react-router-dom';
import { Megaphone, ArrowUpRight } from 'lucide-react';
import { Panel } from './BuyerWidgets';
import { STAGE_COLORS } from './CoreWidgets';

const when = iso => {
  const d = new Date(iso);
  const mins = Math.round((Date.now() - d) / 60000);
  if (mins < 60) return `${Math.max(1, mins)}m ago`;
  if (mins < 1440) return `${Math.round(mins / 60)}h ago`;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};
const isToday = iso => new Date(iso).toDateString() === new Date().toDateString();

export function UpdatesFeedWidget({ items }) {
  const navigate = useNavigate();
  const today = (items || []).filter(u => isToday(u.created_at)).length;
  return (
    <Panel title="Latest Updates" icon={Megaphone} accent="#F97316" testId="widget-updates-feed" className="lg:col-span-6"
      action={<span className="rounded-full bg-orange-500/15 px-2 py-0.5 text-[11px] font-semibold text-orange-300" data-testid="updates-today-count">{today} today</span>}>
      {!items?.length ? <p className="py-8 text-center text-sm text-slate-500" data-testid="updates-empty">No updates yet. Post one from any lead page.</p> : (
        <div className="max-h-80 space-y-1.5 overflow-y-auto pr-1">
          {items.map(u => (
            <button key={u.id} onClick={() => navigate(`/leads/${u.lead_id}`)} data-testid={`feed-update-${u.id}`}
              className="group flex w-full gap-3 rounded-xl px-2.5 py-2 text-left transition-colors hover:bg-[#1A2436]">
              <span className="mt-1 h-2 w-2 shrink-0 rounded-full" style={{ background: STAGE_COLORS[u.status] || '#64748B', boxShadow: `0 0 8px ${STAGE_COLORS[u.status] || '#64748B'}` }} />
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="truncate text-sm font-semibold text-white">{u.address}</span>
                  <span className={`shrink-0 text-[10px] ${isToday(u.created_at) ? 'text-orange-300' : 'text-slate-500'}`}>{when(u.created_at)}</span>
                </span>
                <span className="block text-xs text-slate-400 line-clamp-2">{u.description}</span>
              </span>
              <ArrowUpRight className="mt-0.5 h-4 w-4 shrink-0 text-slate-600 transition-colors group-hover:text-orange-300" />
            </button>
          ))}
        </div>
      )}
    </Panel>
  );
}
